module.exports = __webpack_public_path__ + "public/SiteImages/footerBg.png?fc7031dc";


//////////////////
// WEBPACK FOOTER
// ./public/SiteImages/footerBg.png
// module id = 3306
// module chunks = 8